module.exports = __webpack_public_path__ + "img/fi-water-side-rest-800x527.2cc18f72.jpg";